// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[name=\"OldPopover\"].style-overrides .wrapper > * {\n      width: calc(100vw - 10px) !important;\n    }", ""]);
// Exports
module.exports = exports;
